<app-theme-emitter></app-theme-emitter>

<div id="objlist" class="page-layout carded fullwidth h-100-p" [ngStyle]="{'background-color':_color}">

  <!-- BACKGROUND -->
  <div fxFill style="background-color:#fafafa; z-index:1; position:absolute;"></div>
  <div class="top-bg" [ngStyle]="{'background-color':_color}"></div>
  <!-- / BACKGROUND -->

  <!-- CENTER -->
  <div class="center" fxFlex>

    <!-- HEADER -->
    <div class="header" [ngStyle]="{'color': contrastColor}" fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0" fxLayout="row" fxLayoutAlign="start center">
        <span id="txtContentTitle" class="logo-text h1" *fuseIfOnDom>{{_title}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- ADD BUTTON -->
      <div>
        <button *ngIf="allowAdd" id="btnAdd" mat-fab class="add-button mat-warn" (click)="add()"
          matTooltip="{{('Add ' + type).trim()}}" aria-label="{{('Add ' + type).trim()}}" [style.visibility]="(userReadOnly) ? 'hidden': 'visible'">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <!-- / ADD BUTTON -->

      <!-- TOOLBAR -->
      <div class="toolbar" fxLayout="row" fxLayoutAlign="start center" text-contrast [backgroundColor]="_color">

        <div *ngIf="showPurge" style="display:flex;">
          <button color="secondary" mat-button id="purge" #purgeButton (click)="purge()" aria-label="purge"
            matTooltip="Purge">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">delete_sweep</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Purge</span>
          </button>

          <mat-divider class='style-fix' [vertical]="true"></mat-divider>
        </div>

        <div *ngIf="(hasMultipleRowsSelected  || hasSingleRowSelected) && (!userReadOnly)" style="display:flex;">

          <button *ngIf="canArchive" color="secondary" mat-button id="archive" #archiveButton
            (click)="archiveButton._elementRef.nativeElement.blur();archiveSelectedRows();" aria-label="archive"
            matTooltip="Archive Selected Records">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">archive</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Archive</span>
          </button>

          <button *ngIf="allowDelete && hasMultipleRowsSelected" color="secondary" mat-button id="delete" #deleteButton
            (click)="deleteButton._elementRef.nativeElement.blur();deleteSelectedRows();" aria-label="delete"
            matTooltip="Delete Selected Records">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">delete</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Delete</span>
          </button>

          <button *ngIf="showBatchReAssign && hasMultipleRowsSelected" color="secondary" mat-button
            id="allowBatchReAssign" #allowBatchReAssign
            (click)="allowBatchReAssign._elementRef.nativeElement.blur();batchReAssign();"
            aria-label="Batch Re-Assign Selected Records" matTooltip="Batch Re-Assign Selected Records">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">assignment_ind</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Batch Re-Assign</span>
          </button>
          
          <button *ngIf="enableShowOnMap && hasMultipleRowsSelected" color="secondary" mat-button
            id="enableShowOnMap" #enableShowOnMap
            (click)="enableShowOnMap._elementRef.nativeElement.blur();showOnMap();"
            aria-label="Show Selected Records on Map" matTooltip="Show Selected Records on Map">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">map</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Show on Map</span>
          </button>
                    
          <mat-divider *ngIf="canArchive || (allowDelete && hasMulitpleRowsSelected) || (showBatchReAssign && hasMultipleRowsSelected) || (enableShowOnMap) " class='style-fix' [vertical]="true"></mat-divider>
        </div>

        <div *ngIf="detailTemplate">
          <button mat-button id="expand" (click)="expandAllRows()" aria-label="Expand All" matTooltip="Expand All Records">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">expand_more</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Expand All</span>
          </button>
          <button mat-button id="collapse" (click)="collapseAllRows()" aria-label="Collapse All" matTooltip="Collapse All Records">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">expand_less</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Collapse All</span>
          </button>
        </div>

        <button *ngIf="!showFilter" color="secondary" mat-button id="showFilter" #showFilterButton
          (click)="toggleFilterRow()" matTooltip="Show Filter">
          <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">filter_alt</mat-icon>
          <span [ngStyle]="{'color': contrastColor}">Filter</span>
        </button>

        <button *ngIf="showFilter" color="secondary" mat-button id="showFilter" #hideFilterButton
          (click)="toggleFilterRow()" matTooltip="Hide Filter">
          <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">clear</mat-icon>
          <span [ngStyle]="{'color': contrastColor}">Filter</span>
        </button>

        <button color="secondary" mat-button id="reset" #resetButton (click)="reset()" aria-label="Reset"
          matTooltip="Reset">
          <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">restart_alt</mat-icon>
          <span [ngStyle]="{'color': contrastColor}">Reset</span>
        </button>

        <mat-divider class='style-fix' [vertical]="true"></mat-divider>

        <button color="secondary" mat-button id="export" #exportButton (click)="export()" matTooltip="Export">
          <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">file_download</mat-icon>
          <span [ngStyle]="{'color': contrastColor}">Export</span>
        </button>

        <!-- <button color="secondary" mat-button id="print" #exportButton (click)="print()" matTooltip="Print">
            <mat-icon [ngStyle]="{'color': contrastColor}" class="mr-4">print</mat-icon>
            <span [ngStyle]="{'color': contrastColor}">Print</span>
          </button> -->

      </div>
      <!-- / TOOLBAR -->

    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div #content class="content-card mat-white-bg p-24">
      <data-grid style="max-height: 100%;" [rows]="_rows" [columns]="_columns"
        [allowEdit]="allowEdit && (!userReadOnly)" [allowDelete]="allowDelete" [detailTemplate]="detailTemplate"
        [selectionMode]="selectionMode" [keyProperty]="keyProperty" [storageKey]="storageKey"
        [showLoading]="showLoading" (onDelete)="delete($event)" (onEdit)="edit($event)" (onOpenLink)="openLink($event)"
        (onSelectionChanged)="selectionChanged($event)" (onRowUpdated)="rowUpdated($event)"
        (onFilterVisibilityChanged)="filterVisibilityChanged($event)">
      </data-grid>
    </div>
    <!-- / CONTENT -->

  </div>
  <!-- / CENTER -->
</div>